import styled from "@emotion/styled";
import * as MuiIcons from "@mui/icons-material";
import * as Mui from "@mui/material";
import { Button } from "@mui/material";
import { ColDef, ICellRendererParams, IServerSideGetRowsParams } from "ag-grid-community";
import dayjs from "dayjs";
import { useEffect, useMemo, useState } from "react";
import { customTheme } from "../../../../config/theme/MuiTheme";
import AgGridCustomTable from "../../../../util/component/AgGridCustomTable";
import { useAgGridCustomDatasource } from "../../hooks/useAgGridCustomDatasource";
import useOperationTranslation from "../../hooks/useOperationTranslation";
import Ellipsis from "../common/Ellipsis";
import EmptyStateGrid from "../common/EmptyStateGrid";
import { nameof } from "../common/ObjectUtils";

import { VehicleToBeRepairedService} from "./service/veficleToBe.active";
import { StatusTypes } from "./Type";
import AgGridOperationTable from "../common/AgGridOperationTable";

const StyledDialogTitle = styled(Mui.DialogTitle)({
  marginBottom: "0px !important",
})

interface Props {
  tenant:string;
  open: boolean;
  onClose: () => void;
  kit?: any;
}

const VehicleRepairedDetails = (props: Props) => {
  const [gridApi, setGridApi] = useState<any>(null);
  const [totalElements, setTotalElements] = useState<number>(0);
  const t = useOperationTranslation();
 const [repairStatus,setRepairStataus] = useState<any>([]);

function managerData(response: any) {
  setTotalElements(response.length);
  let rows: any[] = [];
  response.forEach((element: any) => {
    let row = {
      status: element.status,
      statusData: element.statusData,
    };
    rows.push(row);
  });

  return rows;
}
const onGridReady = (params: any) => {
  setGridApi(params.api);
};

function repairedStatusList(){
    return {
      getRows: async (params: IServerSideGetRowsParams) => {
        VehicleToBeRepairedService.get.getRepairStatus(props.tenant,props.kit?.data?.damageFormId)
          .then((response: any) => {
            params.successCallback(
              managerData(response),
              response.length
            );
            

          })
        
      },
    };
}
useEffect(() => {
  if (gridApi) {
    gridApi.setServerSideDatasource(repairedStatusList());
  }
}, [gridApi, props.kit?.data]);
  const columns: ColDef[] = [
    {
      headerName: t("vehicleToBeRepaired.fields.status"),
      field: nameof<StatusTypes.StatusHistory>("status"),
      flex: 1,
      cellRenderer:(params:any)=>{ 
        //let removeDateWord = params.data.status.split(/(?=[A-Z])/).join(" ").replace('Date','');
        //let firstUppercace =removeDateWord.charAt(0).toUpperCase() + removeDateWord.slice(1).toLowerCase()
        return(
          <> {setStatusLabelFromDate(params.data.status)}</>
        )
      }
    },

    {
      headerName: t("vehicleToBeRepaired.vehicleDetailsDialog.statusData"),
      field: nameof<StatusTypes.StatusHistory>("statusData"),
      flex: 1,
       cellRenderer: (params: ICellRendererParams<StatusTypes.StatusHistory>) => {
         return (
        <>
       {dayjs(`${params.data?.statusData}`).format(
               "DD/MM/YYYY HH:mm"
             )}
       </>
         );
       }
    }
  ]

  const setStatusLabelFromDate = (status : any) => {

    if (status === "markedToBeRepairedDate")
      return t("vehicleToBeRepaired.status.marked_to_be_repaired");    
    else if (status === "WORKSHOP_ENGAGEMENT")
      return t("vehicleToBeRepaired.status.workshop_engagement");
    else if (status === "TRANSFER_FOR_WORKSHOP")
      return t("vehicleToBeRepaired.status.transfer_for_workshop");
    else if (status === "wengDate")
      return t("vehicleToBeRepaired.status.workshop_engagement");
    else if (status === "tfWorkDate")
      return t("vehicleToBeRepaired.status.transfer_for_workshop");
    else if (status === "repairDeliveryDate")
      return t("vehicleToBeRepaired.status.arrived_in_repair_shop");
    else if (status === "quoteReceivalDate")
      return t("vehicleToBeRepaired.status.quote_received");
    else if (status === "quoteNegationDate")
      return t("vehicleToBeRepaired.status.quote_denied");
    else if (status === "quoteAuthorizationDate")
      return t("vehicleToBeRepaired.status.quote_approved");
    else if (status === "replacementOrderDate")
      return t("vehicleToBeRepaired.status.spare_parts_ordered");
    else if (status === "replacementUnavailabilityDate")
      return t("vehicleToBeRepaired.status.spare_parts_unavailable ");
    else if (status === "replacementArrivalDate")
      return t("vehicleToBeRepaired.status.spare_parts_received ");
    else if (status === "repairStartDate")
      return t("vehicleToBeRepaired.status.work_started");
    else if (status === "repairEndDate")
      return t("vehicleToBeRepaired.status.work_ended");
    else if (status === "deliveryDate")
      return t("vehicleToBeRepaired.status.returned");
    else
      return status;
    
  }

  const setStatusLabel = (status : any) => {

    console.log(status);

	if (status === "Marked to be Repaired")
      return t("vehicleToBeRepaired.status.marked_to_be_repaired");
    else if (status === "Arrived in Repair Shop")
      return t("vehicleToBeRepaired.status.arrived_in_repair_shop");
    else if (status === "Quote Received")
      return t("vehicleToBeRepaired.status.quote_received");
    else if (status === "Quote Denied")
      return t("vehicleToBeRepaired.status.quote_denied");
    else if (status === "Quote Approved")
      return t("vehicleToBeRepaired.status.quote_approved");
    else if (status === "Spare Parts Ordered")
      return t("vehicleToBeRepaired.status.spare_parts_ordered");
    else if (status === "Spare Parts Unavailable")
      return t("vehicleToBeRepaired.status.spare_parts_unavailable ");
    else if (status === "Spare Parts Received")
      return t("vehicleToBeRepaired.status.spare_parts_received ");
    else if (status === "Work Started")
      return t("vehicleToBeRepaired.status.work_started");
    else if (status === "Work Ended")
      return t("vehicleToBeRepaired.status.work_ended");
    else if (status === "Returned")
      return t("vehicleToBeRepaired.status.returned");
    else
      return status;
    

  }
 

  return (
    <Mui.Dialog open={props.open} onClose={props.onClose} fullWidth maxWidth="lg">
      <StyledDialogTitle>
        <Mui.Grid container  alignItems="center" spacing={2}>
          <Mui.Grid item xs={4}>
            <Mui.Typography variant="h5">{t("vehicleToBeRepaired.vehicleDetailsDialog.title")}</Mui.Typography>
          </Mui.Grid>

          <Mui.Grid item xs={8}>
            <Mui.Grid container alignItems="center" justifyContent="flex-end" spacing={2.5}>
              <Mui.Grid item xs={11} >
                <Mui.Stack direction="row" alignItems="center" color={customTheme.palette.accent.main} justifyContent="end">
                    <Ellipsis textAlign="end">                      
                        <Mui.Typography display="inline" variant="body" color="inherit">{t("vehicleToBeRepaired.fields.damageForm")}:</Mui.Typography>
                        <Mui.Typography display="inline" variant="h6" color="inherit" ml="5px">{props.kit?.data?.formProgressive} -</Mui.Typography>
                        <Mui.Typography display="inline" variant="body"color="inherit"> {t("vehicleToBeRepaired.fields.plate")}:</Mui.Typography>
                        <Mui.Typography display="inline" variant="h6" ml="5px" color="inherit">{props.kit?.data?.plate} - </Mui.Typography>
                        <Mui.Typography display="inline" variant="body" color="inherit"> {t("vehicleToBeRepaired.fields.status")}:</Mui.Typography>
                        <Mui.Typography display="inline" variant="h6" ml="5px" color="inherit">{setStatusLabel(props.kit?.data?.status)}</Mui.Typography>                     
                    </Ellipsis>
                </Mui.Stack>
              </Mui.Grid>

              <Mui.Grid item xs={'auto'}>
                <Button variant="text" size="icon" color ="inherit"  onClick={props.onClose}>
                  <MuiIcons.Close />
                </Button>
              </Mui.Grid>
            </Mui.Grid>
          </Mui.Grid>
          
       
         </Mui.Grid>
       </StyledDialogTitle>
       <Mui.DialogContent>
       </Mui.DialogContent>
          <AgGridOperationTable
          columnDefs={columns}
          onGridReady={onGridReady}
          serverSideInfiniteScroll={true}
          rowModelType={"serverSide"}
          rowSelection={'multiple'}
          paginationPageSize={500}
          pagination={false}
          totalElements={totalElements}
          emptyState={{
            title: t("vehicleEquipmentAssociation.dialogs.watchKit.table.emptyState.title"),
            content: t("vehicleEquipmentAssociation.dialogs.watchKit.table.emptyState.content")
          }}
        />

     
     </Mui.Dialog>

  )
}

export default VehicleRepairedDetails;